
import Component from '../../../assets/scripts/modules/component'
import fireCustomEvent from '../../../assets/scripts/utilities/fire-custom-event'

let timeout
const THROTTLE_DELAY = 350

export default class MenuBarComponent extends Component {
  init () {
    this.buttonMenu = this.element.querySelector('.button--menu')
    this.buttonClose = this.element.querySelector('.button--close')
    this.buttonLogin = this.element.querySelector('.button--login')
    this.isAnimating = false

    if (!this.buttonMenu || !this.buttonClose) {
      return
    }

    this.buttonLogin?.addEventListener('click', () => localStorage.setItem('login', true))
    this.buttonMenu.addEventListener('click', () => !this.isAnimating && fireCustomEvent('open-menu-overlay'))
    this.buttonClose.addEventListener('click', () => !this.isAnimating && fireCustomEvent('close-menu-overlay'))
    document.documentElement.addEventListener('keydown', event => event.keyCode === 27 && !this.isAnimating && fireCustomEvent('close-menu-overlay'))

    window.addEventListener('open-menu-overlay', () => this.openOverlay())
    window.addEventListener('close-menu-overlay', () => this.closeOverlay())

    if (this.element.querySelector('.menu-bar__department-title') && this.element.classList.contains('menu-bar--local')) {
      window.addEventListener('scroll', () => this.onDocumentScrollHandler(), { passive: true })
    }

    this.submitLogin()
  }

  submitLogin () {
    this.form = document.forms['openid-connect-login-form']
    if (localStorage.login && this.form) {
      const fullPath = window.location.pathname + window.location.search
      localStorage.removeItem('login')
      this.form.action = fullPath
      this.form.submit()
    }
  }

  openOverlay () {
    if (this.element.classList.contains('menu-bar--overlay-open')) {
      return
    }

    this.isAnimating = true
    this.element.classList.add('menu-bar--overlay-open')

    window.clearTimeout(timeout)
    timeout = window.setTimeout(() => {
      this.isAnimating = false
    }, THROTTLE_DELAY)
  }

  closeOverlay () {
    if (!this.element.classList.contains('menu-bar--overlay-open')) {
      return
    }

    this.isAnimating = true
    this.element.classList.remove('menu-bar--overlay-open')

    window.clearTimeout(timeout)
    timeout = window.setTimeout(() => {
      this.isAnimating = false
    }, THROTTLE_DELAY)
  }

  onDocumentScrollHandler () {
    const switchPosition = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--menu-bar-height') || 0, 10)
    const bufferAmount = 30

    if (document.scrollingElement.scrollTop > switchPosition + bufferAmount) {
      this.element.classList.add('menu-bar--document-scrolled')
    } else if (document.scrollingElement.scrollTop < switchPosition - bufferAmount) {
      this.element.classList.remove('menu-bar--document-scrolled')
    }
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.menu-bar').forEach(element => {
  element.instance = element.instance || new MenuBarComponent(element)
}))
